{
  "familyId": "MET-OPP-LAND",
  "questions": [
    {
      "id": "MET-OPP-LAND-001",
      "familyId": "MET-OPP-LAND",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_landmaten",
      "questionType": "multiple_choice",
      "question": "Een voetbalveld is 7.000 m². Hoeveel hectare is dat?",
      "context": null,
      "options": ["0,7 hectare", "7 hectare", "70 hectare", "0,07 hectare"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "area",
            "from": "m²",
            "to": "ha"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "area",
            "from": "m²",
            "to": "ha",
            "value": 7000,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "area_m2_to_hectare",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "1 hectare = 10.000 m² (een vierkant van 100 m × 100 m). Om van m² naar hectare te gaan, deel je door 10.000. Dus: 7.000 ÷ 10.000 = 0,7 hectare. Waarom delen? Omdat hectare een grotere eenheid is dan m² — je hebt minder hectares nodig om hetzelfde oppervlak uit te drukken. Controleer: 0,7 × 10.000 = 7.000 m² ✓",
        "solutionSteps": [
          "Onthoud: 1 hectare = 10.000 m² (100 m × 100 m)",
          "Van m² naar hectare = grotere eenheid, dus delen",
          "Deel: 7.000 ÷ 10.000 = 0,7 hectare",
          "Controleer: 0,7 × 10.000 = 7.000 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 7.000 ÷ 10.000 = 0,7 hectare. Bij omrekenen naar een grotere eenheid deel je altijd.",
          "1": "Je dacht waarschijnlijk dat 1 hectare = 1.000 m². Maar 1 hectare = 10.000 m² (100 m × 100 m). Dus 7.000 ÷ 10.000 = 0,7 hectare, niet 7. Onthoud: hectare = 10.000 m².",
          "2": "Je dacht waarschijnlijk dat je moet vermenigvuldigen. Maar als je van een kleine eenheid (m²) naar een grote eenheid (hectare) gaat, deel je. 7.000 ÷ 10.000 = 0,7 hectare. Onthoud: naar groter = delen.",
          "3": "Je dacht waarschijnlijk dat je door 100.000 moet delen. Maar 1 hectare = 10.000 m², niet 100.000 m². 7.000 ÷ 10.000 = 0,7 hectare. Onthoud: ha = 10.000 m²."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-hectare-1000", "label": "Denkt dat 1 hectare = 1000 m²", "optionIndex": 1 },
          { "id": "met.opp-richting-fout", "label": "Vermenigvuldigt in plaats van te delen", "optionIndex": 2 },
          { "id": "met.opp-hectare-100000", "label": "Denkt dat 1 hectare = 100.000 m²", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-LAND-002",
      "familyId": "MET-OPP-LAND",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_landmaten",
      "questionType": "multiple_choice",
      "question": "Een boer heeft een weiland van 3 hectare. Hoeveel vierkante meter is dat?",
      "context": null,
      "options": ["3.000 m²", "300 m²", "30.000 m²", "300.000 m²"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "area",
            "from": "ha",
            "to": "m²"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "area",
            "from": "ha",
            "to": "m²",
            "value": 3,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "area_hectare_to_m2",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "1 hectare = 10.000 m². Van hectare naar m² ga je naar een kleinere eenheid, dus vermenigvuldig je. 3 × 10.000 = 30.000 m². Waarom vermenigvuldigen? Omdat je meer vierkante meters nodig hebt om hetzelfde oppervlak uit te drukken. Controleer: 30.000 ÷ 10.000 = 3 hectare ✓",
        "solutionSteps": [
          "Onthoud: 1 hectare = 10.000 m²",
          "Van hectare naar m² = kleinere eenheid, dus vermenigvuldigen",
          "Bereken: 3 × 10.000 = 30.000 m²",
          "Controleer: 30.000 ÷ 10.000 = 3 hectare ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 1 hectare = 1.000 m². Maar 1 hectare = 10.000 m². Dus 3 × 10.000 = 30.000 m², niet 3.000. Onthoud: hectare = 10.000 m².",
          "1": "Je dacht waarschijnlijk dat 1 hectare = 100 m². Maar 1 hectare = 10.000 m² (100 × 100). 3 × 10.000 = 30.000 m². Onthoud: ha is een groot oppervlak.",
          "2": "Goed! 3 × 10.000 = 30.000 m². Naar een kleinere eenheid = vermenigvuldigen.",
          "3": "Je dacht waarschijnlijk dat 1 hectare = 100.000 m². Maar 1 hectare = 10.000 m². 3 × 10.000 = 30.000 m², niet 300.000. Onthoud: ha = 10.000 m²."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-hectare-1000", "label": "Denkt dat 1 hectare = 1000 m²", "optionIndex": 0 },
          { "id": "met.opp-hectare-100", "label": "Denkt dat 1 hectare = 100 m²", "optionIndex": 1 },
          { "id": "met.opp-hectare-100000", "label": "Denkt dat 1 hectare = 100.000 m²", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-LAND-003",
      "familyId": "MET-OPP-LAND",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_landmaten",
      "questionType": "multiple_choice",
      "question": "Een tuin is 500 m². Hoeveel are is dat?",
      "context": null,
      "options": ["50 are", "5 are", "0,5 are", "500 are"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "area",
            "from": "m²",
            "to": "are"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Landmaten: are",
            "content": "1 are = 100 m² (een vierkant van 10 m × 10 m).\n1 hectare = 100 are = 10.000 m².\nVan m² naar are: deel door 100.\n500 ÷ 100 = 5 are.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_m2_to_are",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "1 are = 100 m² (een vierkant van 10 m × 10 m). Van m² naar are deel je door 100: 500 ÷ 100 = 5 are. Waarom is de are handig? Voor middelgrote oppervlakken zoals tuinen en percelen. De are zit tussen m² (klein) en hectare (groot) in. Onthoud het trapje: m² → are (÷100) → hectare (÷100).",
        "solutionSteps": [
          "Onthoud: 1 are = 100 m² (10 m × 10 m)",
          "Van m² naar are = grotere eenheid, dus delen",
          "Deel: 500 ÷ 100 = 5 are",
          "Controleer: 5 × 100 = 500 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 1 are = 10 m². Maar 1 are = 100 m² (10 × 10). Dus 500 ÷ 100 = 5 are, niet 50. Onthoud: are = 100 m².",
          "1": "Goed! 500 ÷ 100 = 5 are. De are is handig voor middelgrote oppervlakken.",
          "2": "Je dacht waarschijnlijk dat 1 are = 1.000 m². Maar 1 are = 100 m². 500 ÷ 100 = 5 are, niet 0,5. Onthoud: are = 100 m², hectare = 10.000 m².",
          "3": "Je dacht waarschijnlijk dat are en m² hetzelfde zijn. Maar 1 are = 100 m². 500 m² = 5 are, niet 500 are. Onthoud: van m² naar are deel je door 100."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-are-10", "label": "Denkt dat 1 are = 10 m²", "optionIndex": 0 },
          { "id": "met.opp-are-1000", "label": "Denkt dat 1 are = 1000 m²", "optionIndex": 2 },
          { "id": "met.opp-are-gelijk-aan-m2", "label": "Behandelt are en m² als gelijk", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-LAND-004",
      "familyId": "MET-OPP-LAND",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_landmaten",
      "questionType": "multiple_choice",
      "question": "Een natuurgebied is 250 hectare groot. Hoeveel vierkante kilometer is dat?",
      "context": null,
      "options": ["25 km²", "0,25 km²", "250 km²", "2,5 km²"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hectare en vierkante kilometer",
            "content": "1 km² = 100 hectare (want 1 km = 1.000 m, dus 1 km² = 1.000 × 1.000 = 1.000.000 m² = 100 hectare).\nVan hectare naar km²: deel door 100.\n250 ÷ 100 = 2,5 km².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_hectare_to_km2",
      "variantIndex": 4,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "1 km² = 100 hectare. Waarom? Omdat 1 km = 1.000 m, dus 1 km² = 1.000 × 1.000 = 1.000.000 m². En 1.000.000 ÷ 10.000 = 100 hectare. Van hectare naar km² deel je door 100: 250 ÷ 100 = 2,5 km². Dit is een lastige omrekening omdat je bij oppervlaktematen altijd met het kwadraat werkt.",
        "solutionSteps": [
          "Onthoud: 1 km² = 100 hectare",
          "Van hectare naar km² = grotere eenheid, dus delen",
          "Deel: 250 ÷ 100 = 2,5 km²",
          "Controleer: 2,5 × 100 = 250 hectare ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 1 km² = 10 hectare. Maar 1 km² = 100 hectare (want bij oppervlaktematen werk je met het kwadraat). 250 ÷ 100 = 2,5 km². Onthoud: km² = 100 ha.",
          "1": "Je dacht waarschijnlijk dat 1 km² = 1.000 hectare. Maar 1 km² = 100 hectare. 250 ÷ 100 = 2,5 km², niet 0,25. Onthoud: km² = 100 ha.",
          "2": "Je dacht waarschijnlijk dat hectare en km² hetzelfde zijn. Maar 1 km² = 100 hectare. 250 hectare = 2,5 km², niet 250 km². Onthoud: van ha naar km² deel je door 100.",
          "3": "Goed! 250 ÷ 100 = 2,5 km². Onthoud: 1 km² = 100 hectare."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-km2-ha-10", "label": "Denkt dat 1 km² = 10 hectare", "optionIndex": 0 },
          { "id": "met.opp-km2-ha-1000", "label": "Denkt dat 1 km² = 1000 hectare", "optionIndex": 1 },
          { "id": "met.opp-ha-gelijk-aan-km2", "label": "Behandelt hectare en km² als gelijk", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-OPP-LAND-005",
      "familyId": "MET-OPP-LAND",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_landmaten",
      "questionType": "fill_in",
      "question": "Een boerderij heeft 45.000 m² grond. Hoeveel hectare is dat? Typ je antwoord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["4,5", "4.5", "4,5 hectare", "4,5 ha"],
        "caseSensitive": false,
        "placeholder": "... hectare"
      },
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "area",
            "from": "m²",
            "to": "ha"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "area",
            "from": "m²",
            "to": "ha",
            "value": 45000,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "area_m2_to_hectare_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "1 hectare = 10.000 m². Van m² naar hectare deel je door 10.000: 45.000 ÷ 10.000 = 4,5 hectare. Waarom delen? Omdat hectare een grotere eenheid is. Controleer: 4,5 × 10.000 = 45.000 m² ✓. Tip: bij grote getallen kun je de nullen wegstrepen: 45.000 ÷ 10.000 = 45 ÷ 10 = 4,5.",
        "solutionSteps": [
          "Onthoud: 1 hectare = 10.000 m²",
          "Van m² naar hectare: deel door 10.000",
          "Bereken: 45.000 ÷ 10.000 = 4,5 hectare",
          "Controleer: 4,5 × 10.000 = 45.000 m² ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-m2-naar-ha-fout", "label": "Maakt fout bij delen door 10.000 om m² naar hectare te zetten" }
        ]
      }
    }
  ]
}